import { useMutation, useQuery } from "@tanstack/react-query";
import { api, backendApi } from "./api.service";

type PaginationRequest = {
  page?: number;
  pageSize?: number;
  name?: string;
};

export const useGetReferralById = (
  id: string,
  pagination: PaginationRequest,
) => {
  const config = { withCredentials: true, params: pagination };
  return useQuery({
    queryKey: ["get-referrals-by-user", pagination],
    queryFn: () =>
      backendApi.get(`/admin/referral/referrals-by-user/${id}`, config),
  });

  // return useMutation({
  //   mutationFn: ({ id, page, pageSize }: { id: string; page: number; pageSize: number }) => {
  //     return api.get(`/profile/settings/rakeback/user/${id}/incoming`, {
  //       params: {
  //         page,
  //         pageSize,
  //       },
  //     });
  //   },
  // });
};

export const useGenerateByUser = (userId: string) => {
  const config = { withCredentials: true };
  return useQuery({
    queryKey: ["get-all-roles", userId],
    queryFn: () =>
      backendApi.get(`/admin/referral/generate-by-user/${userId}`, config),
  });
};

export const useGetAllReferrals = () => {
  const config = { withCredentials: true };
  return useQuery({
    queryKey: ["get-all-referrals"],
    queryFn: async () => {
      const response = await backendApi.get(
        `/profile/settings/referral/get-all-referral-by-lvl`,
        config,
      );
      const data = await response.data.data;
      return data;
    },
    retry: 0,
  });
};

export const useGetReferralDownlines = (level: string) => {
  const config = { withCredentials: true };
  return useQuery({
    queryKey: ["get-downlines", level],
    queryFn: async () => {
      const response = await backendApi.get(
        `/profile/settings/referral/downlines/${level}`,
        config,
      );
      const data = await response.data.data;
      return data;
    },
    retry: 0,
  });
};

export const useGetAllReferralByLevel = (
  level: string,
  pagination: PaginationRequest,
) => {
  const config = { withCredentials: true, params: pagination };
  return useQuery({
    queryKey: ["get-all-referral-by-level", level],
    queryFn: async () =>
      await backendApi.get(
        `/profile/settings/referral/get-all-referral-by-lvl/${level}`,
        config,
      ),
  });
};

export const useReferralGenerateByOwner = () => {
  const config = { withCredentials: true };

  return useQuery({
    queryKey: ["get-referral-generate-by-owner"],
    queryFn: async () => {
      const response = await api.get(
        "/profile/settings/referral/generate-by-owner",
        config,
      );
      return response.data;
    },
  });
};

export const useClaimAllReferral = () => {
  return useMutation({
    mutationFn: (data: { referrId: string }) => {
      return api.post("/profile/settings/referral/claim-all", data);
    },
  });
};
